const SECTION_SELECTOR = '[data-section-type="base-garments"]';
const INPUT_SELECTOR = '.base-garments__swatch-input';
const ITEM_SELECTOR = '.base-garments__item';
const IMAGE_SELECTOR = 'img.base-garments__img';
const SWAPPING_CLASS = 'is-swapping';

function preload(url) {
  return new Promise((resolve) => {
    const loader = new Image();
    loader.onload = resolve;
    loader.onerror = resolve;
    loader.src = url;
  });
}

async function showVariantImage(item, input) {
  const image = item.querySelector(IMAGE_SELECTOR);
  const { image: src, imageAlt: alt } = input.dataset;
  if (!image || !src || image.currentSrc === src) return;

  await preload(src);

  image.classList.add(SWAPPING_CLASS);
  image.addEventListener(
    'transitionend',
    () => {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
      if (alt) image.alt = alt;
      image.classList.remove(SWAPPING_CLASS);
    },
    { once: true }
  );

  // transitionend never fires when motion is reduced or the swap is instant.
  setTimeout(() => {
    if (!image.classList.contains(SWAPPING_CLASS)) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    if (alt) image.alt = alt;
    image.classList.remove(SWAPPING_CLASS);
  }, 250);
}

document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
  section.addEventListener('change', (event) => {
    const input = event.target.closest(INPUT_SELECTOR);
    if (!input) return;

    const item = input.closest(ITEM_SELECTOR);
    if (item) showVariantImage(item, input);
  });
});
